import WebGalleryPasswordEntry from './WebGalleryPasswordEntry';

export default WebGalleryPasswordEntry;
